import colors from './colors';

const theme = {
  colors,
  maxWidth: '1185px',
  noteMaxWidth: '900px',
  media: {
    tablet: '@media (min-width: 728px)',
    desktop: '@media (min-width: 1024px)',
  },
};

export default theme;
